module.exports = __webpack_public_path__ + "img/product-shansuan-zsyy-10.4819a593.png";